import styled from "@emotion/styled";
import axios from "axios";
import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// import "./auth.css";
function Signup() {
  const [isformSubmitLoading, setIsFormSubmitLoading] = useState(false);
  const [openValidation, setOpenValidation] = useState(false);
  const [detail, setDetail] = useState({});
  const [firstName, setFName] = useState("");
  const [lastName, setLName] = useState("");
  const [email, setEmail] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [isd, setIsd] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [error, setError] = useState({
    phoneNo: "",
    firstName: "",
    lastName: "",
    message: "",
    email: "",
    companyName: "",
  });
  const [message, setMessage] = useState("");
  const [response, setResponse] = useState({ success: "", message: "" });
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpenValidation(false);
    setResponse({ success: "", message: "" });
  };

  const handleMessage = (e) => {
    e.preventDefault();

    // Reset errors first
    const newError = {
      phoneNo: "",
      firstName: "",
      lastName: "",
      message: "",
      email: "",
      companyName: "",
    };

    let hasError = false;

    if (firstName.trim() === "") {
      newError.firstName = "First Name is required";
      hasError = true;
    }
    if (lastName.trim() === "") {
      newError.lastName = "Last Name is required";
      hasError = true;
    }
    if (email.trim() === "") {
      newError.email = "Email is required";
      hasError = true;
    }
    if (companyName.trim() === "") {
      newError.email = "Company Name is required";
      hasError = true;
    }
    if (phoneNo.trim() === "") {
      newError.phoneNo = "Contact Number is required";
      hasError = true;
    }
    if (message.trim() === "") {
      newError.message = "Message is required";
      hasError = true;
    }

    setError(newError);

    if (hasError) {
      return; // Prevent form submission
    }

    const phone = phoneNo.slice(`+${isd}`.length - 1).trim();

    const data = {
      firstName,
      lastName,
      isd,
      phoneNo: phone,
      message,
      email,
      companyName,
    };

    sendRequest(data);
  };

  console.log("res", response);

  const sendRequest = async (data) => {
    // e.preventDefault();
    // setResponse({ success: true, message: "" });
    setIsFormSubmitLoading(true);
    try {
      const res = await axios.post("/contact/send-demo-request", data);
      // console.log("resss", res.data);
      setResponse({
        success: true,
        message:
          "Request for demo has successfully been sent! The team will contact you shortly.",
      });
      setOpenValidation(true);

      setTimeout(() => {
        setEmail("");
        setIsd("");
        setPhoneNo("");
        setFName("");
        setLName("");
        setMessage("");
        setCompanyName("");
        // setResponse({ success: "", message: "" });
      }, 4000);
    } catch (error) {
      console.log(error);
      setOpenValidation(true);

      if (error.status === 400) {
        setResponse({ success: false, message: "Mail couldn't be sent!" });
      } else
        setResponse({ success: false, message: "All Fields are required" });
    } finally {
      setIsFormSubmitLoading(false);
      // setResponse({ success: "", message: "" });
    }
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <div className="signup-section">
        <div className="book-demo">
          <div className="container1">
            <div className="container1-demo">
              <div className="left">
                <h5>SCHEDULE A LIVE DEMO</h5>
                <h1 style={{ color: "white" }}>
                  Goodbye guesswork. Hello business growth!
                </h1>
                <p>
                  The end-to-end automation platform to boost productivity for
                  sales, marketing, service, and field teams.
                </p>

                <p>
                  <strong>What can Clidex do for you?</strong>
                </p>
                <ul>
                  <li>
                    <img className="" src="/assets/images/bullet_icon.svg" />
                    Increase funnel quality by 50%
                  </li>
                  <li>
                    <img className="" src="/assets/images/bullet_icon.svg" />
                    The end-to-end automation platform to boost productivity for
                    sales, marketing, service, and field teams.
                  </li>
                  <li>
                    <img className="" src="/assets/images/bullet_icon.svg" />
                    Build end-to-end sales, service, and marketing workflows
                    with zero code
                  </li>
                  <li>
                    <img className="" src="/assets/images/bullet_icon.svg" />
                    Add one more: Empower field teams with mobile CRM
                  </li>
                </ul>
              </div>
              <div className="right">
                <div className="form-box">
                  <h2>Get a demo</h2>
                  <p>We’re here to answer all your questions!</p>
                  <form>
                    <div className="form-group">
                      <input
                        value={firstName}
                        type="text"
                        className="form-control"
                        placeholder="First Name"
                        required
                        onChange={(e) => {
                          setFName(e.target.value);
                          if (error.firstName)
                            setError((prev) => ({
                              ...prev,
                              firstName: "",
                            }));
                        }}
                      />
                      {error.firstName && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "2px",
                          }}
                        >
                          {error.firstName}
                        </div>
                      )}
                      <input
                        value={lastName}
                        type="text"
                        className="form-control"
                        placeholder="Last Name"
                        required
                        onChange={(e) => {
                          setLName(e.target.value);
                          if (error.lastName)
                            setError((prev) => ({
                              ...prev,
                              lastName: "",
                            }));
                        }}
                      />
                      {error.lastName && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "2px",
                          }}
                        >
                          {error.lastName}
                        </div>
                      )}
                    </div>
                    <input
                      type="email"
                      required
                      className="form-control"
                      placeholder="Email"
                      onChange={(e) => {
                        setEmail(e.target.value);
                        if (error.email)
                          setError((prev) => ({ ...prev, email: "" }));
                      }}
                      value={email}
                    />
                    {error.email && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "2px",
                        }}
                      >
                        {error.email}
                      </div>
                    )}
                    <input
                      type="text"
                      required
                      className="form-control"
                      placeholder="Company Name"
                      onChange={(e) => {
                        setCompanyName(e.target.value);
                        if (error.companyName)
                          setError((prev) => ({ ...prev, companyName: "" }));
                      }}
                      value={companyName}
                    />
                    {error.companyName && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "2px",
                        }}
                      >
                        {error.companyName}
                      </div>
                    )}
                    {/* <input type="text" placeholder="Company *" required="" /> */}
                    <div className="form-group">
                      <PhoneInput
                        country={"in"}
                        value={phoneNo}
                        required
                        onChange={(phone, country) => {
                          setIsd(country.dialCode || "");
                          setPhoneNo(phone);
                          if (error.phoneNo)
                            setError((prev) => ({
                              ...prev,
                              phoneNo: "",
                            }));
                        }}
                        inputStyle={{
                          // padding: '20px',
                          fontSize: "12px",
                          color: "#333",
                          borderRadius: "10px",
                          width: "100%",
                          marginBottom: "10px",
                        }}
                      />
                      {error.phoneNo && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "2px",
                          }}
                        >
                          {error.phoneNo}
                        </div>
                      )}
                    </div>
                    <textarea
                      required
                      className="form-control mt-3"
                      placeholder="Message"
                      defaultValue={""}
                      onChange={(e) => {
                        setMessage(e.target.value);
                        if (error.message)
                          setError((prev) => ({
                            ...prev,
                            message: "",
                          }));
                      }}
                      value={message}
                    />
                    {error.message && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "2px",
                        }}
                      >
                        {error.message}
                      </div>
                    )}
                    <button
                      type="button"
                      className="btn"
                      onClick={handleMessage}
                      disabled={isformSubmitLoading}
                    >
                      {isformSubmitLoading
                        ? "Sending Request ..."
                        : "Request a Demo"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {openValidation && (
        <Popup>
          <div className="popup-overlay">
            <div className="popup">
              <div className="verify" style={{ height: "100px" }}>
                <img
                  src={
                    response.success
                      ? "/assets/images/check.png"
                      : "/assets/images/mark.png"
                  }
                  style={{ height: "100%" }}
                />
              </div>
              <h3>{response.success ? "Thank You!" : "Error"}</h3>
              <p style={{ color: "black" }}>{response.message}</p>
              <button className="new-btn" onClick={() => handleClose()}>
                Okay
              </button>
            </div>
          </div>
        </Popup>
      )}
    </>
  );
}

export default Signup;
const Popup = styled.div`
  .popup-overlay {
    position: fixed; /* overlay on top of all content */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    animation: fadeIn 0.3s ease-in-out;
  }

  /* Popup box */
  .popup {
    background: white;
    padding: 30px;
    border-radius: 10px;
    text-align: center;
    color: white;
    width: 350px;
    transform: scale(0.8);
    animation: popupIn 0.3s forwards;
  }

  /* Animations */
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes popupIn {
    from {
      opacity: 0;
      transform: scale(0.8);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .popup button {
    margin-top: 20px;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;
    font-weight: bold;
    width: 60%;
  }
`;
